// import React, { useState, useMemo } from "react";
// import { Box, Grid, Button } from "@mui/material";
// import Header from "components/Header";
// import MaterialReactTable from "material-react-table";
// import { useTheme } from "@mui/system";

// const Dpmsr = () => {
//   const theme = useTheme();
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [addDialogOpen, setAddDialogOpen] = useState(false);
//   const [currentRowData, setCurrentRowData] = useState(null);

//   const columns = useMemo(() => [], []);

//   return (
//     <Box m="1.5rem 2.5rem">
//       <Header title="DPMSR" subtitle="Transactions Reporting" />

//       <Box
//         mt="40px"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": { border: "none" },
//           "& .MuiDataGrid-cell": { borderBottom: "none" },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: theme.palette.background.alt,
//             color: theme.palette.secondary[100],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: theme.palette.primary.light,
//           },
//           "& .MuiDataGrid-footerContainer": {
//             backgroundColor: theme.palette.background.alt,
//             color: theme.palette.secondary[100],
//             borderTop: "none",
//           },
//         }}
//       >
//         <MaterialReactTable
//           data={[]}
//           columns={columns}
//           renderTopToolbarCustomActions={({ table }) => (
//             <Box style={{ width: "900px" }}>
//               <Grid container spacing={2}>
//                 <Grid item>
//                   <Button
//                     variant="outlined"
//                     color="secondary"
//                     // onClick={handleOpenAddDialog}
//                   >
//                     Add New
//                   </Button>
//                 </Grid>
//                 <Grid item>
//                   <Button
//                     variant="outlined"
//                     color="success"
//                     // onClick={exportToExcel}
//                   >
//                     Export
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         />
//       </Box>

//       {/* Modals */}
//       {/* Add dialog */}
//       {/* Edit dialog */}
//     </Box>
//   );
// };

// export default Dpmsr;

import React, { useState, useMemo } from "react";
import { dropdownFields } from "./dropdownFields";
import {
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { countryListAlpha2 } from "data/data";
import { useDebounce } from "use-debounce";
import { useGetSearchEntitiesQuery } from "../../state/api"; // Import the query
import { useAuth } from "../../contexts/AuthContext";
import {
  useGetGoodsAndServicesQuery,
  useCreateGoodsAndServicesMutation,
} from "../../state/api";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Header from "components/Header";
import MaterialReactTable from "material-react-table";
import { useTheme } from "@mui/system";
import moment from "moment";
import { create } from "@mui/material/styles/createTransitions";

const Dpmsr = () => {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [formData, setFormData] = useState(null);
  const { data: dpmsrData, error, isLoading } = useGetGoodsAndServicesQuery(); // Fetch the goods and services data

  // Use RTK Query with inputValue as the query parameter
  const { data, isFetching } = useGetSearchEntitiesQuery(
    { query: inputValue, limit: 10 },
    { skip: inputValue.length < 3 } // Skip the query until the user types at least 3 characters
  );

  const handleCancel = () => {
    setFormData(null); // Reset the state to null
    handleAddDialogClose(); // Close the dialog
  };

  console.log("dpmsrData:", dpmsrData);

  const columns = useMemo(
    () => [
      {
        accessorKey: "created_at",
        header: "Created At",
        Cell: ({ cell }) =>
          new Date(cell.getValue()).toLocaleDateString("En-gb"), // Format date
      },
      {
        accessorKey: "entity.fullLegalName",
        header: "Entity Name",
      },
    ],
    []
  );

  const transactionColumns = useMemo(
    () => [
      {
        accessorKey: "item_type",
        header: "Item Type",
      },
      {
        accessorKey: "disposed_value",
        header: "Disposed Value",
        Cell: ({ cell }) =>
          cell.getValue() ? cell.getValue().toLocaleString() : "N/A",
      },
      {
        accessorKey: "currency_code",
        header: "Currency Code",
      },
      {
        accessorKey: "status_comments",
        header: "Status Comments",
      },
    ],
    []
  );

  const handleAddDialogOpen = () => {
    setAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setAddDialogOpen(false);
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="DPMSR" subtitle="Transactions Reporting" />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
        }}
      >
        {!isLoading ? (
          <MaterialReactTable
            data={dpmsrData || []}
            columns={columns}
            renderTopToolbarCustomActions={({ table }) => (
              <Box style={{ width: "900px" }}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleAddDialogOpen}
                    >
                      Add New
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" color="success">
                      Export
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
            renderDetailPanel={({ row }) => (
              <div style={{ display: "grid" }} key={row.original._id}>
                <Typography variant="h5" gutterBottom>
                  Transactions
                </Typography>
                <MaterialReactTable
                  columns={transactionColumns} // Use transaction columns
                  data={row.original.goods_services || []} // Pass goods_services data
                  id={row.original._id}
                  key={row.original._id}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  enablePagination={false}
                  enableSorting={false}
                  enableBottomToolbar={false}
                  enableTopToolbar={false}
                  layoutMode="grid"
                />
              </div>
            )}
          />
        ) : (
          <p>Loading data...</p>
        )}
      </Box>

      {/* Add New Dialog */}
      <Dialog
        open={addDialogOpen}
        onClose={handleAddDialogClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Typography color={"secondary"} fontWeight={"bold"}>
            New Report
          </Typography>
        </DialogTitle>
        <DialogContent>
          {formData ? (
            <FormComponent1
              initialData={formData}
              onCancel={handleCancel} // Pass the onCancel function
            />
          ) : (
            <SearchEntities onSelect={(selected) => setFormData(selected)} />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const FormComponent1 = ({ initialData, onCancel }) => {
  const { user } = useAuth();
  const director = selectAuthorizedOrUBO(initialData?.shareHolders);
  const { firstName, lastName } = ((name = "") => {
    const [firstName, ...rest] = name.trim().split(" ");
    return { firstName, lastName: rest.join(" ") };
  })(director?.fullLegalName);

  const [addNew, { isLoading: isSubmitting, isSuccess, error }] =
    useCreateGoodsAndServicesMutation();

  const handleCancel = () => {
    if (onCancel) {
      onCancel(); // Call the onCancel function if it exists
    } else {
      console.error("onCancel function is not defined.");
    }
  };

  //   const submitData = () => {
  //     // Call the API to submit the data  here
  //     generateXML();
  //     console.log("Submitting data: ", formData.goods_services);
  //     console.log("initial data: ", initialData);
  //     addNew.mutate(formData);
  //   };

  const submitData = async () => {
    if (!formData || !formData.goods_services) {
      console.error("Form data or goods services are missing!");
      return;
    }

    try {
      console.log("Submitting data: ", formData.goods_services);
      console.log("Initial data: ", initialData);

      // Trigger the mutation
      await addNew({
        entityId: initialData?._id, // Assuming `initialData` has an `_id` field for the entity
        goods_services: formData.goods_services,
      }).unwrap(); // Unwrap ensures you handle resolved/rejected promises

      // Generate XML after successful submission
      generateXML();
      console.log("Data submitted successfully.");
    } catch (err) {
      console.error("Error submitting data:", err);
    }
  };

  //   const isGenerateXMLDisabled = () => {
  //     const requiredFields = [
  //       formData.goods_services.length > 0, // Ensure there is at least one item
  //       formData.entity_reference.trim() !== "",
  //       formData.reason_for_reporting.trim() !== "",
  //       formData.director_role.trim() !== "",
  //     ];

  //     return requiredFields.some((field) => !field); // If any field is empty, disable the button
  //   };

  const isGenerateXMLDisabled = () => {
    const requiredFields = [
      formData.goods_services.length > 0, // Ensure goods_services is not empty
      formData.entity_reference.trim() !== "",
      formData.reason_for_reporting.trim() !== "",
      formData.director_role.trim() !== "",
    ];

    // Check if all fields in goods_services are non-empty
    const areGoodsServicesValid = formData.goods_services.every(
      (service) =>
        service.item_type?.trim() !== "" &&
        service.status_comments?.trim() !== "" &&
        service.disposed_value?.trim() !== "" &&
        service.currency_code?.trim() !== ""
    );

    return requiredFields.some((field) => !field) || !areGoodsServicesValid; // Disable if any field is invalid
  };

  console.log("initialData  : ", initialData);
  const [formData, setFormData] = useState({
    rentity_id: user?.fiuOrgID,
    submission_code: "E",
    report_code: "DPMSR",
    entity_reference: "",
    submission_date: moment().format("YYYY-MM-DDTHH:mm:ss"),
    currency_code_local: "AED",
    gender: "M",
    title: "Mr",
    first_name: "",
    last_name: "",
    birthdate: "",
    ssn: "",
    tph_contact_type: "",
    tph_communication_type: "",
    tph_country_prefix: "",
    tph_number: "",
    first_name_Controlling_person: user?.controllingPerson?.first_name,
    last_name_Controlling_person: user?.controllingPerson?.last_name,
    birthdate_Controlling_person: moment(
      user?.controllingPerson?.birthdate
    ).format("YYYY-MM-DDTHH:mm:ss"),
    ssn_Controlling_person: user?.controllingPerson?.ssn,
    nationality1_Controlling_person:
      user?.controllingPerson?.nationality,
    tph_contact_type_Controlling_person:
      user?.controllingPerson?.tph_contact_type,
    tph_communication_type_Controlling_person:
      user?.controllingPerson?.tph_communication_type,
    tph_country_prefix_Controlling_person:
      user?.controllingPerson?.tph_country_prefix,
    tph_number_Controlling_person: user?.controllingPerson?.tph_number,
    address_type_Controlling_person:
      user?.controllingPerson?.address_type,
    address_Controlling_person: user?.controllingPerson?.address,
    city_Controlling_person: user?.controllingPerson?.city,
    country_code_Controlling_person:
      user?.controllingPerson?.country_code,
    state_Controlling_person: user?.controllingPerson?.state,
    email_Controlling_person: user?.controllingPerson?.email,
    occupation_Controlling_person: user?.controllingPerson?.occupation,
    reason: "REPORTING DPMSR TO FIU AS PER MOE MANDATE",
    reason_for_reporting: "",
    // Related to Customer
    name: initialData?.fullLegalName,
    incorporation_legal_form:
      "Wholesale of Jewellery, Diamonds and Precious Stones",
    incorporation_number: initialData?.TradeLicenseInfo.tradeLicenseNo,
    incorporation_date: moment(
      initialData?.TradeLicenseInfo.incoroprationDate
    ).format("YYYY-MM-DD"),
    incorporation_country_code: findCountryKey(
      initialData?.TradeLicenseInfo.countryofIncorporation
    ),
    // findCountryKeyByValue(
    //   //   "Pakistan",
    //   dropdownFields.incorporation_country_code,
    //   initialData?.TradeLicenseInfo.countryofIncorporation
    //   //   dropdownFields.incorporation_country_code
    // ),
    director_role: "",
    director_first_name: firstName,
    director_last_name: lastName,
    director_birthdate: moment(director?.doB).format("YYYY-MM-DD"),
    director_id_number: director.idDoc.number,
    director_identification_type:
      director.idDoc.type === "Passport"
        ? "PP"
        : director.idDoc.type === "Emirates ID"
        ? "EID"
        : director.idDoc.type,
    director_issue_date: moment(director?.idDoc.issueDate).format("YYYY-MM-DD"),
    director_expiry_date: moment(director?.idDoc.expiryDate).format(
      "YYYY-MM-DD"
    ),
    director_issue_country: findCountryKey(director?.idDoc.issueCountry),
    pep: hasPEP(initialData),

    tax_reg_number: initialData?.taxNo,
    transaction_reason: "",
    // item_type: "GOLD",
    // status_comments: "CASH PAYMENT AED 3,980,000",
    // disposed_value: "3980000",
    // currency_code: "AED",
    indicator: "",
    goods_services: [],
    // Continue with other fields as necessary
  });

  // const handleInputChange = (event, index = null) => {
  //   const { name, value } = event.target;

  //   if (index !== null) {
  //     const updatedGoodsServices = formData.goods_services.map((item, i) =>
  //       i === index ? { ...item, [name]: value } : item
  //     );
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       goods_services: updatedGoodsServices,
  //     }));
  //   } else {
  //     setFormData((prevState) => ({ ...prevState, [name]: value }));
  //   }
  // };

  const handleInputChange = (event, index = null) => {
    const { name, value } = event.target;
    const formattedValue = isDateField(name)
      ? value
        ? moment(value).format("YYYY-MM-DDTHH:mm:ss")
        : moment().format("YYYY-MM-DD") + "T00:00:00" // Set time to 00:00:00
      : value;

    if (index !== null) {
      // Update an item in an array field like goods_services
      const updatedGoodsServices = formData.goods_services.map((item, i) =>
        i === index ? { ...item, [name]: value } : item
      );
      setFormData((prevState) => ({
        ...prevState,
        goods_services: updatedGoodsServices,
      }));
    } else {
      // Update a simple field
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const addItem = () => {
    setFormData({
      ...formData,
      goods_services: [
        ...formData.goods_services,
        {
          item_type: "",
          status_comments: "",
          disposed_value: "",
          currency_code: "",
        },
      ],
    });
  };

  const removeItem = (index) => {
    setFormData({
      ...formData,
      goods_services: formData.goods_services.filter((_, i) => i !== index),
    });
  };

  const staticFields = [
    "rentity_id",
    "gender",
    "title",
    "first_name",
    "last_name",
    "birthdate",
    "ssn",
    "nationality1",
    "tph_contact_type",
    "tph_communication_type",
    "tph_country_prefix",
    "tph_number",
    "address_type",
    "address",
    "city",
    "country_code",
    "state",
    "email",
    "occupation",
    "reason",
    "report_code",
    "submission_code",
    "submission_date",
    "incorporation_legal_form",
    "indicator",
    // "director_first_name",
    // "director_last_name",
    // "director_birthdate",
    // "id_number",
    // "identification_type",
    // "identification_number",
    // "issue_date",
    // "expiry_date",
    // "issue_country",
    // "role",
    // "incorporation_date",
    // "tax_reg_number",
    // "transaction_reason",
  ];

  const generateXML = () => {
    const itemsXML = formData.goods_services
      .map(
        (item) =>
          `<item>
          <item_type>${item.item_type}</item_type>
          <status_comments>${item.status_comments}</status_comments>
          <disposed_value>${item.disposed_value}</disposed_value>
          <currency_code>${item.currency_code}</currency_code>
        </item>`
      )
      .join("");

    const xmlData = `
  <report>
    <rentity_id>${formData.rentity_id}</rentity_id>
    <submission_code>${formData.submission_code}</submission_code>
    <report_code>${formData.report_code}</report_code>
    <entity_reference>${formData.entity_reference}</entity_reference>
    <submission_date>${formData.submission_date}</submission_date>
    <currency_code_local>${formData.currency_code_local}</currency_code_local>
      <reporting_person>
        <gender>${formData.gender}</gender>
        <title>${formData.title}</title>
        <first_name>${formData.first_name_Controlling_person}</first_name>
        <last_name>${formData.last_name_Controlling_person}</last_name>
        <birthdate>${formData.birthdate_Controlling_person}</birthdate>
        <ssn>${formData.ssn_Controlling_person}</ssn>
        <nationality1>${formData.nationality1_Controlling_person}</nationality1>
        <phones>
          <phone>
            <tph_contact_type>${
              formData.tph_contact_type_Controlling_person
            }</tph_contact_type>
            <tph_communication_type>${
              formData.tph_communication_type_Controlling_person
            }</tph_communication_type>
            <tph_country_prefix>${
              formData.tph_country_prefix_Controlling_person
            }</tph_country_prefix>
            <tph_number>${formData.tph_number_Controlling_person}</tph_number>
          </phone>
        </phones>
        <addresses>
          <address>
            <address_type>${
              formData.address_type_Controlling_person
            }</address_type>
            <address>${formData.address_Controlling_person}</address>
            <city>${formData.city_Controlling_person}</city>
            <country_code>${
              formData.country_code_Controlling_person
            }</country_code>
            <state>${formData.state_Controlling_person}</state>
          </address>
        </addresses>
        <email>${formData.email_Controlling_person}</email>
        <occupation>${formData.occupation_Controlling_person}</occupation>
      </reporting_person>
      <location>
        <address_type>${formData.address_type_Controlling_person}</address_type>
        <address>${formData.address_Controlling_person}</address>
        <city>${formData.city_Controlling_person}</city>
        <country_code>${formData.country_code_Controlling_person}</country_code>
        <state>${formData.state_Controlling_person}</state>
      </location>
      <reason>${formData.reason}</reason>
      <activity>
        <report_parties>
          <report_party>
            <entity>
              <name>${formData.name}</name>
              <incorporation_legal_form>${"WJDPS"}</incorporation_legal_form>
              <incorporation_number>${
                formData.incorporation_number
              }</incorporation_number>
              <incorporation_country_code>${
                formData.incorporation_country_code
              }</incorporation_country_code>
              <director_id>
                <first_name>${formData.director_first_name}</first_name>
                <last_name>${formData.director_last_name}</last_name>
                <birthdate>${
                  formData.director_birthdate + "T00:00:00"
                }</birthdate>
                <id_number>${formData.director_id_number}</id_number>
                <identification>
                  <type>${formData.director_identification_type}</type>
                  <number>${formData.director_id_number}</number>
                  <issue_date>${
                    formData.director_issue_date + "T00:00:00"
                  }</issue_date>
                  <expiry_date>${
                    formData.director_expiry_date + "T00:00:00"
                  }</expiry_date>
                  <issue_country>${
                    formData.director_issue_country
                  }</issue_country>
                </identification>
                <role>${formData.director_role}</role>
              </director_id>
              <incorporation_date>${
                formData.incorporation_date + "T00:00:00"
              }</incorporation_date>
              <tax_reg_number>${formData.tax_reg_number}</tax_reg_number>
            </entity>
            <reason>${formData.transaction_reason}</reason>
          </report_party>
        </report_parties>
    </activity>
    <goods_services>
      ${itemsXML}
    </goods_services>
  </report>
      `;

    const blob = new Blob([xmlData], { type: "application/xml" });
    const link = document.createElement("a");
    const dateTime = new Date()
      .toISOString()
      .replace(/[-:]/g, "")
      .replace("T", "_")
      .split(".")[0];
    link.href = URL.createObjectURL(blob);
    link.download = `DPMSR${dateTime}.xml`;
    link.click();
  };

  // Function to convert field names to readable labels
  const toLabel = (fieldName) => {
    // Split field names at underscores or camelCase and capitalize the first letter of each word
    return fieldName
      .replace(/([A-Z])/g, " $1")
      .replace(/(_)/g, " ")
      .replace(/(^.)/, (str) => str.toUpperCase());
  };

  // Function to determine if a field is a date field78
  const isDateField = (fieldName) => {
    const dateFields = [
      "birthdate",
      "issue_date",
      "expiry_date",
      "incorporation_date",
      "director_birthdate",
      "director_issue_date",
      "director_expiry_date",
    ]; // Add other date fields here
    return dateFields.includes(fieldName);
  };

  //   const dropdownFields = {
  //     indicator: [
  //       { key: "DPMSJ", value: "Transaction with Entity/Companies" },
  //       { key: "DPMSI", value: "Transaction with Resident Individuals" },
  //       { key: "DPMSN", value: "Transaction with Non Resident Individuals" },
  //     ],
  //     director_issue_country: [],
  //     incorporation_country_code: [
  //       { key: "AD", value: "ANDORRA" },
  //       { key: "AE", value: "UNITED ARAB EMIRATES" },
  //       { key: "AF", value: "AFGHANISTAN" },
  //       { key: "AG", value: "ANTIGUA AND BARBUDA" },
  //       { key: "AI", value: "ANGUILLA" },
  //       { key: "AL", value: "ALBANIA" },
  //       { key: "AM", value: "ARMENIA" },
  //       { key: "AN", value: "NETHERLANDS ANTILLES" },
  //       { key: "AO", value: "ANGOLA" },
  //       { key: "AQ", value: "ANTARCTICA" },
  //       { key: "AR", value: "ARGENTINA" },
  //       { key: "AS", value: "AMERICAN SAMOA" },
  //       { key: "AT", value: "AUSTRIA" },
  //       { key: "AU", value: "AUSTRALIA" },
  //       { key: "AW", value: "ARUBA" },
  //       { key: "AX", value: "ÅLAND ISLANDS" },
  //       { key: "AZ", value: "AZERBAIJAN" },
  //       { key: "BA", value: "BOSNIA AND HERZEGOVINA" },
  //       { key: "BB", value: "BARBADOS" },
  //       { key: "BD", value: "BANGLADESH" },
  //       { key: "BE", value: "BELGIUM" },
  //       { key: "BF", value: "BURKINA FASO" },
  //       { key: "BG", value: "BULGARIA" },
  //       { key: "BH", value: "BAHRAIN" },
  //       { key: "BI", value: "BURUNDI" },
  //       { key: "BJ", value: "BENIN" },
  //       { key: "BM", value: "BERMUDA" },
  //       { key: "BN", value: "BRUNEI DARUSSALAM" },
  //       { key: "BO", value: "BOLIVIA" },
  //       { key: "BR", value: "BRAZIL" },
  //       { key: "BS", value: "BAHAMAS" },
  //       { key: "BT", value: "BHUTAN" },
  //       { key: "BU", value: "BURMA" },
  //       { key: "BV", value: "BOUVET ISLAND" },
  //       { key: "BW", value: "BOTSWANA" },
  //       { key: "BY", value: "BELARUS" },
  //       { key: "BZ", value: "BELIZE" },
  //       { key: "CA", value: "CANADA" },
  //       { key: "CC", value: "COCOS (KEELING) ISLANDS" },
  //       { key: "CD", value: "CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
  //       { key: "CF", value: "CENTRAL AFRICAN REPUBLIC" },
  //       { key: "CG", value: "CONGO" },
  //       { key: "CH", value: "SWITZERLAND" },
  //       { key: "CI", value: "COTE D'IVOIRE" },
  //       { key: "CK", value: "COOK ISLANDS" },
  //       { key: "CL", value: "CHILE" },
  //       { key: "CM", value: "CAMEROON" },
  //       { key: "CN", value: "CHINA" },
  //       { key: "CO", value: "COLOMBIA" },
  //       { key: "CR", value: "COSTA RICA" },
  //       { key: "CS", value: "SERBIA AND MONTENEGRO" },
  //       { key: "CU", value: "CUBA" },
  //       { key: "CV", value: "CAPE VERDE" },
  //       { key: "CX", value: "CHRISTMAS ISLAND" },
  //       { key: "CY", value: "CYPRUS" },
  //       { key: "CZ", value: "CZECH REPUBLIC" },
  //       { key: "DE", value: "GERMANY" },
  //       { key: "DJ", value: "DJIBOUTI" },
  //       { key: "DK", value: "DENMARK" },
  //       { key: "DM", value: "DOMINICA" },
  //       { key: "DO", value: "DOMINICAN REPUBLIC" },
  //       { key: "DZ", value: "ALGERIA" },
  //       { key: "EC", value: "ECUADOR" },
  //       { key: "EE", value: "ESTONIA" },
  //       { key: "EG", value: "EGYPT" },
  //       { key: "EH", value: "WESTERN SAHARA" },
  //       { key: "ER", value: "ERITREA" },
  //       { key: "ES", value: "SPAIN" },
  //       { key: "ET", value: "ETHIOPIA" },
  //       { key: "FI", value: "FINLAND" },
  //       { key: "FJ", value: "FIJI" },
  //       { key: "FK", value: "FALKLAND ISLANDS (MALVINAS)" },
  //       { key: "FM", value: "MICRONESIA, FEDERATED STATES OF" },
  //       { key: "FO", value: "FAROE ISLANDS" },
  //       { key: "FR", value: "FRANCE" },
  //       { key: "GA", value: "GABON" },
  //       { key: "GB", value: "UNITED KINGDOM" },
  //       { key: "GD", value: "GRENADA" },
  //       { key: "GE", value: "GEORGIA" },
  //       { key: "GF", value: "FRENCH GUIANA" },
  //       { key: "GG", value: "GUERNSEY" },
  //       { key: "GH", value: "GHANA" },
  //       { key: "GI", value: "GIBRALTAR" },
  //       { key: "GL", value: "GREENLAND" },
  //       { key: "GM", value: "GAMBIA" },
  //       { key: "GN", value: "GUINEA" },
  //       { key: "GP", value: "GUADELOUPE" },
  //       { key: "GQ", value: "EQUATORIAL GUINEA" },
  //       { key: "GR", value: "GREECE" },
  //       { key: "GS", value: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
  //       { key: "GT", value: "GUATEMALA" },
  //       { key: "GU", value: "GUAM" },
  //       { key: "GW", value: "GUINEA-BISSAU" },
  //       { key: "GY", value: "GUYANA" },
  //       { key: "HK", value: "HONG KONG" },
  //       { key: "HM", value: "HEARD ISLAND AND MCDONALD ISLANDS" },
  //       { key: "HN", value: "HONDURAS" },
  //       { key: "HR", value: "CROATIA" },
  //       { key: "HT", value: "HAITI" },
  //       { key: "HU", value: "HUNGARY" },
  //       { key: "ID", value: "INDONESIA" },
  //       { key: "IE", value: "IRELAND" },
  //       { key: "IL", value: "ISRAEL" },
  //       { key: "IM", value: "ISLE OF MAN" },
  //       { key: "IN", value: "INDIA" },
  //       { key: "IO", value: "BRITISH INDIAN OCEAN TERRITORY" },
  //       { key: "IQ", value: "IRAQ" },
  //       { key: "IR", value: "IRAN, ISLAMIC REPUBLIC OF" },
  //       { key: "IS", value: "ICELAND" },
  //       { key: "IT", value: "ITALY" },
  //       { key: "JE", value: "JERSEY" },
  //       { key: "JM", value: "JAMAICA" },
  //       { key: "JO", value: "JORDAN" },
  //       { key: "JP", value: "JAPAN" },
  //       { key: "KE", value: "KENYA" },
  //       { key: "KG", value: "KYRGYZSTAN" },
  //       { key: "KH", value: "CAMBODIA" },
  //       { key: "KI", value: "KIRIBATI" },
  //       { key: "KM", value: "COMOROS" },
  //       { key: "KN", value: "SAINT KITTS AND NEVIS" },
  //       { key: "KP", value: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
  //       { key: "KR", value: "KOREA, REPUBLIC OF" },
  //       { key: "KW", value: "KUWAIT" },
  //       { key: "KY", value: "CAYMAN ISLANDS" },
  //       { key: "KZ", value: "KAZAKHSTAN" },
  //       { key: "LA", value: "LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
  //       { key: "LB", value: "LEBANON" },
  //       { key: "LC", value: "SAINT LUCIA" },
  //       { key: "LI", value: "LIECHTENSTEIN" },
  //       { key: "LK", value: "SRI LANKA" },
  //       { key: "LR", value: "LIBERIA" },
  //       { key: "LS", value: "LESOTHO" },
  //       { key: "LT", value: "LITHUANIA" },
  //       { key: "LU", value: "LUXEMBOURG" },
  //       { key: "LV", value: "LATVIA" },
  //       { key: "LY", value: "LIBYAN ARAB JAMAHIRIYA" },
  //       { key: "MA", value: "MOROCCO" },
  //       { key: "MC", value: "MONACO" },
  //       { key: "MD", value: "MOLDOVA, REPUBLIC OF" },
  //       { key: "ME", value: "MONTENEGRO" },
  //       { key: "MG", value: "MADAGASCAR" },
  //       { key: "MH", value: "MARSHALL ISLANDS" },
  //       { key: "MK", value: "MACEDONIA" },
  //       { key: "ML", value: "MALI" },
  //       { key: "MM", value: "MYANMAR" },
  //       { key: "MN", value: "MONGOLIA" },
  //       { key: "MO", value: "MACAO" },
  //       { key: "MP", value: "NORTHERN MARIANA ISLANDS" },
  //       { key: "MQ", value: "MARTINIQUE" },
  //       { key: "MR", value: "MAURITANIA" },
  //       { key: "MS", value: "MONTSERRAT" },
  //       { key: "MT", value: "MALTA" },
  //       { key: "MU", value: "MAURITIUS" },
  //       { key: "MV", value: "MALDIVES" },
  //       { key: "MW", value: "MALAWI" },
  //       { key: "MX", value: "MEXICO" },
  //       { key: "MY", value: "MALAYSIA" },
  //       { key: "MZ", value: "MOZAMBIQUE" },
  //       { key: "NA", value: "NAMIBIA" },
  //       { key: "NC", value: "NEW CALEDONIA" },
  //       { key: "NE", value: "NIGER" },
  //       { key: "NF", value: "NORFOLK ISLAND" },
  //       { key: "NG", value: "NIGERIA" },
  //       { key: "NI", value: "NICARAGUA" },
  //       { key: "NL", value: "NETHERLANDS" },
  //       { key: "NO", value: "NORWAY" },
  //       { key: "NP", value: "NEPAL" },
  //       { key: "NR", value: "NAURU" },
  //       { key: "NU", value: "NIUE" },
  //       { key: "NZ", value: "NEW ZEALAND" },
  //       { key: "OM", value: "OMAN" },
  //       { key: "PA", value: "PANAMA" },
  //       { key: "PE", value: "PERU" },
  //       { key: "PF", value: "FRENCH POLYNESIA" },
  //       { key: "PG", value: "PAPUA NEW GUINEA" },
  //       { key: "PH", value: "PHILIPPINES" },
  //       { key: "PK", value: "PAKISTAN" },
  //       { key: "PL", value: "POLAND" },
  //       { key: "PM", value: "SAINT PIERRE AND MIQUELON" },
  //       { key: "PN", value: "PITCAIRN" },
  //       { key: "PR", value: "PUERTO RICO" },
  //       { key: "PS", value: "PALESTINIAN TERRITORY, OCCUPIED" },
  //       { key: "PT", value: "PORTUGAL" },
  //       { key: "PW", value: "PALAU" },
  //       { key: "PY", value: "PARAGUAY" },
  //       { key: "QA", value: "QATAR" },
  //       { key: "RE", value: "REUNION" },
  //       { key: "RO", value: "ROMANIA" },
  //       { key: "RS", value: "SERBIA" },
  //       { key: "RU", value: "RUSSIAN FEDERATION" },
  //       { key: "RW", value: "RWANDA" },
  //       { key: "SA", value: "SAUDI ARABIA" },
  //       { key: "SB", value: "SOLOMON ISLANDS" },
  //       { key: "SC", value: "SEYCHELLES" },
  //       { key: "SD", value: "SUDAN" },
  //       { key: "SE", value: "SWEDEN" },
  //       { key: "SG", value: "SINGAPORE" },
  //       { key: "SH", value: "SAINT HELENA" },
  //       { key: "SI", value: "SLOVENIA" },
  //       { key: "SJ", value: "SVALBARD AND JAN MAYEN" },
  //       { key: "SK", value: "SLOVAKIA" },
  //       { key: "SL", value: "SIERRA LEONE" },
  //       { key: "SM", value: "SAN MARINO" },
  //       { key: "SN", value: "SENEGAL" },
  //       { key: "SO", value: "SOMALIA" },
  //       { key: "SR", value: "SURINAME" },
  //       { key: "ST", value: "SAO TOME AND PRINCIPE" },
  //       { key: "SV", value: "EL SALVADOR" },
  //       { key: "SY", value: "SYRIAN ARAB REPUBLIC" },
  //       { key: "SZ", value: "SWAZILAND" },
  //       { key: "TC", value: "TURKS AND CAICOS ISLANDS" },
  //       { key: "TD", value: "CHAD" },
  //       { key: "TF", value: "FRENCH SOUTHERN TERRITORIES" },
  //       { key: "TG", value: "TOGO" },
  //       { key: "TH", value: "THAILAND" },
  //       { key: "TJ", value: "TAJIKISTAN" },
  //       { key: "TK", value: "TOKELAU" },
  //       { key: "TL", value: "TIMOR-LESTE" },
  //       { key: "TM", value: "TURKMENISTAN" },
  //       { key: "TN", value: "TUNISIA" },
  //       { key: "TO", value: "TONGA" },
  //       { key: "TR", value: "TURKEY" },
  //       { key: "TT", value: "TRINIDAD AND TOBAGO" },
  //       { key: "TV", value: "TUVALU" },
  //       { key: "TW", value: "TAIWAN, PROVINCE OF CHINA" },
  //       { key: "TZ", value: "TANZANIA, UNITED REPUBLIC OF" },
  //       { key: "UA", value: "UKRAINE" },
  //       { key: "UG", value: "UGANDA" },
  //       { key: "UM", value: "UNITED STATES MINOR OUTLYING ISLANDS" },
  //       { key: "US", value: "UNITED STATES" },
  //       { key: "UY", value: "URUGUAY" },
  //       { key: "UZ", value: "UZBEKISTAN" },
  //       { key: "VA", value: "HOLY SEE (VATICAN CITY STATE)" },
  //       { key: "VC", value: "SAINT VINCENT AND THE GRENADINES" },
  //       { key: "VE", value: "VENEZUELA" },
  //       { key: "VG", value: "VIRGIN ISLANDS, BRITISH" },
  //       { key: "VI", value: "VIRGIN ISLANDS, U.S." },
  //       { key: "VN", value: "VIET NAM" },
  //       { key: "VU", value: "VANUATU" },
  //       { key: "WF", value: "WALLIS AND FUTUNA" },
  //       { key: "WS", value: "SAMOA" },
  //       { key: "YE", value: "YEMEN" },
  //       { key: "YT", value: "MAYOTTE" },
  //       { key: "YU", value: "YUGOSLAVIA" },
  //       { key: "ZA", value: "SOUTH AFRICA" },
  //       { key: "ZM", value: "ZAMBIA" },
  //       { key: "ZR", value: "ZAIRE" },
  //       { key: "ZW", value: "ZIMBABWE" },
  //     ],
  //     nationality1: [],
  //     director_identification_type: [
  //       { key: "PP", value: "Passport" },
  //       { key: "EID", value: "Emirates ID" },
  //     ],
  //     director_role: [
  //       { key: "ATR", value: "Authorized Signatory" },
  //       { key: "MGR", value: "Manager" },
  //       { key: "PRTNR", value: "Partner" },
  //       { key: "SHRHL", value: "Share Holder" },
  //       { key: "UBO", value: "Ultimete Beneficial Owner" },
  //     ],
  //     item_type: [
  //       { key: "GOLD", value: "Gold" },
  //       { key: "DIMND", value: "Diamond" },
  //       { key: "JEWEL", value: "Jewellery" },
  //       { key: "GEM", value: "Gem Stones" },
  //     ],
  //     currency_code: [
  //       { key: "ADP", value: "Andorran Peseta (no longer in use)" },
  //       { key: "AED", value: "United Arab Emirates Dirham" },
  //       { key: "AFA", value: "Afghani" },
  //       { key: "ALL", value: "Leek" },
  //       { key: "AMD", value: "Dram" },
  //       { key: "ANG", value: "Netherlands Antilles Guilder" },
  //       { key: "AOK", value: "Kwanza" },
  //       { key: "AON", value: "New Kwanza" },
  //       { key: "ARA", value: "Austral" },
  //       { key: "ARP", value: "Argentinean Peso" },
  //       { key: "ARS", value: "Argentinean Nuevo Peso" },
  //       { key: "ATS", value: "Schilling (no longer in use)" },
  //       { key: "AUD", value: "Australian Dollar" },
  //       { key: "AWG", value: "Aruban Guilder" },
  //       { key: "AZM", value: "Azerbaijani Manat" },
  //       { key: "BAM", value: "Convertible Mark" },
  //       { key: "BBD", value: "Barbados Dollar" },
  //       { key: "BDT", value: "Taka" },
  //       { key: "BGL", value: "Lev" },
  //       { key: "BHD", value: "Bahraini Dinar" },
  //       { key: "BIF", value: "Burundi Franc" },
  //       { key: "BMD", value: "Bermudian Dollar" },
  //       { key: "BND", value: "Brunei Dollar" },
  //       { key: "BOB", value: "Boliviano" },
  //       { key: "BOP", value: "Bolivian Peso" },
  //       { key: "BRC", value: "Cruzeiro" },
  //       { key: "BRL", value: "Real" },
  //       { key: "BRR", value: "Cruzeiro Real" },
  //       { key: "BSD", value: "Bahamian Dollar" },
  //       { key: "BTN", value: "Ngultrum" },
  //       { key: "BUK", value: "Replaced by MMK" },
  //       { key: "BWP", value: "Pula" },
  //       { key: "BYR", value: "Belarussian Rouble" },
  //       { key: "BZD", value: "Belize Dollar" },
  //       { key: "CAD", value: "Canadian Dollar" },
  //       { key: "CDF", value: "Congolese Franc" },
  //       { key: "CDZ", value: "New Zaïre" },
  //       { key: "CHF", value: "Swiss Franc" },
  //       { key: "CLF", value: "Unidades de Fomento" },
  //       { key: "CLP", value: "Chilean Peso" },
  //       { key: "CNY", value: "Yuan Renminbi" },
  //       { key: "COP", value: "Colombian Peso" },
  //       { key: "CRC", value: "Costa Rican Colón" },
  //       { key: "CSK", value: "Koruna of former Czechoslovakia" },
  //       { key: "CUP", value: "Cuban Peso" },
  //       { key: "CVE", value: "Escudo Caboverdiano" },
  //       { key: "CYP", value: "Cypriot Pound" },
  //       { key: "CZK", value: "Czech Koruna" },
  //       { key: "DDM", value: "Former East German Mark" },
  //       { key: "DEM", value: "Deutsche Mark (no longer in use)" },
  //       { key: "DJF", value: "Djibouti Franc" },
  //       { key: "DKK", value: "Danish Krone" },
  //       { key: "DOP", value: "Dominican Republic Peso" },
  //       { key: "DZD", value: "Algerian Dinar" },
  //       { key: "ECS", value: "Sucre (no longer in use)" },
  //       { key: "EEK", value: "Kroon" },
  //       { key: "EGP", value: "Egyptian Pound" },
  //       { key: "ERN", value: "Eritrean Nakfa" },
  //       { key: "ESA", value: "Spanish Peseta, Account A (no longer in use)" },
  //       { key: "ESB", value: "Spanish Peseta, Account B (no longer in use)" },
  //       { key: "ESP", value: "Spanish Peseta (no longer in use)" },
  //       { key: "ETB", value: "Ethiopian Birr" },
  //       { key: "EUR", value: "Euro" },
  //       { key: "FIM", value: "Markka (no longer in use)" },
  //       { key: "FJD", value: "Fiji Dollar" },
  //       { key: "FKP", value: "Falkland Pound" },
  //       { key: "FRF", value: "French Franc (no longer in use)" },
  //       { key: "GBP", value: "Pound Sterling (United Kingdom Pound)" },
  //       { key: "GEL", value: "Lari" },
  //       { key: "GHC", value: "Cedi" },
  //       { key: "GIP", value: "Gibraltar Pound" },
  //       { key: "GMD", value: "Dalasi" },
  //       { key: "GNS", value: "Syli (also known as Guinea Franc)" },
  //       { key: "GQE", value: "Ekwele" },
  //       { key: "GRD", value: "Greek Drachma (no longer in use)" },
  //       { key: "GTQ", value: "Quetzal" },
  //       { key: "GWP", value: "Guinea-Bissau Peso" },
  //       { key: "GYD", value: "Guyana Dollar" },
  //       { key: "HKD", value: "Hong Kong Dollar" },
  //       { key: "HNL", value: "Lempira" },
  //       { key: "HRD", value: "Croatian Dinar" },
  //       { key: "HRK", value: "Croatian Kuna" },
  //       { key: "HTG", value: "Gourde" },
  //       { key: "HUF", value: "Forint" },
  //       { key: "IDR", value: "Rupiah" },
  //       { key: "IEP", value: "Punt (no longer in use)" },
  //       { key: "ILS", value: "Shekel" },
  //       { key: "INR", value: "Indian Rupee" },
  //       { key: "IQD", value: "Iraqi Dinar" },
  //       { key: "IRR", value: "Iranian Rial" },
  //       { key: "ISK", value: "Icelandic Króna" },
  //       { key: "ITL", value: "Italian Lira (no longer in use)" },
  //       { key: "JMD", value: "Jamaican Dollar" },
  //       { key: "JOD", value: "Jordanian Dinar" },
  //       { key: "JPY", value: "Yen" },
  //       { key: "KES", value: "Kenyan Shilling" },
  //       { key: "KGS", value: "Kyrgyzstani Som" },
  //       { key: "KHR", value: "Riel" },
  //       { key: "KMF", value: "Comorian Franc" },
  //       { key: "KPW", value: "Democratic People's Republic of Korean Won" },
  //       { key: "KRW", value: "Republic of Korean Won" },
  //       { key: "KWD", value: "Kuwaiti Dinar" },
  //       { key: "KYD", value: "Cayman Islands Dollar" },
  //       { key: "KZT", value: "Tenge" },
  //       { key: "LAK", value: "Kip" },
  //       { key: "LBP", value: "Lebanese Pound" },
  //       { key: "LKR", value: "Sri Lankan Rupee" },
  //       { key: "LRD", value: "Liberian Dollar" },
  //       { key: "LSL", value: "Loti" },
  //       { key: "LSM", value: "Maloti" },
  //       { key: "LTL", value: "Litas" },
  //       { key: "LUF", value: "Luxembourg Franc (no longer in use)" },
  //       { key: "LVL", value: "Lats" },
  //       { key: "LYD", value: "Libyan Dinar" },
  //       { key: "MAD", value: "Moroccan Dirham" },
  //       { key: "MDL", value: "Moldavian Leu" },
  //       { key: "MGF", value: "Malagasy Franc" },
  //       { key: "MKD", value: "Macedonian Dinar" },
  //       { key: "MLF", value: "Malian Franc" },
  //       { key: "MMK", value: "Kyat" },
  //       { key: "MNT", value: "Tugrik" },
  //       { key: "MOP", value: "Pataca" },
  //       { key: "MRO", value: "Ouguiya" },
  //       { key: "MTL", value: "Maltese Lira" },
  //       { key: "MTP", value: "Maltese Pound, replaced by Maltese Lira" },
  //       { key: "MUR", value: "Mauritius Rupee" },
  //       { key: "MVR", value: "Rufiyaa" },
  //       { key: "MWK", value: "Malawian Kwacha" },
  //       { key: "MXN", value: "Mexican New Peso (replacement for Mexican Peso)" },
  //       { key: "MXP", value: "Mexican Peso, replaced by Mexican New Peso" },
  //       { key: "MYR", value: "Ringgit (also known as Malaysian Dollar)" },
  //       { key: "MZM", value: "Metical" },
  //       { key: "NAD", value: "Namibian Dollar" },
  //       { key: "NGN", value: "Naira" },
  //       { key: "NIC", value: "Córdoba" },
  //       { key: "NLG", value: "Dutch Guilder (no longer in use)" },
  //       { key: "NOK", value: "Norwegian Krone" },
  //       { key: "NPR", value: "Nepalese Rupee" },
  //       { key: "NZD", value: "New Zealand Dollar" },
  //       { key: "OMR", value: "Omani Rial" },
  //       { key: "PAB", value: "Balboa" },
  //       { key: "PEI", value: "Inti" },
  //       { key: "PEN", value: "New Sol" },
  //       { key: "PES", value: "Sol (replaced by New Sol [PEN])" },
  //       { key: "PGK", value: "Kina" },
  //       { key: "PHP", value: "Philippines Peso" },
  //       { key: "PKR", value: "Pakistani Rupee" },
  //       { key: "PLN", value: "New Zloty" },
  //       { key: "PLZ", value: "Zloty (replaced by New Zloty [PLN])" },
  //       { key: "PTE", value: "Portuguese Escudo (no longer in use)" },
  //       { key: "PYG", value: "Guarani" },
  //       { key: "QAR", value: "Qatari Riyal" },
  //       { key: "ROL", value: "Romanian Leu" },
  //       { key: "RSD", value: "Serbian Dinar" },
  //       { key: "RUB", value: "Russian Federation Rouble (formerly RUR)" },
  //       { key: "RWF", value: "Rwandan Franc" },
  //       { key: "SAR", value: "Saudi Riyal" },
  //       { key: "SBD", value: "Solomon Islands Dollar" },
  //       { key: "SCR", value: "Seychelles Rupee" },
  //       { key: "SDD", value: "Sudanese Dinar" },
  //       { key: "SDP", value: "Sudanese Pound" },
  //       { key: "SEK", value: "Swedish Krona" },
  //       { key: "SGD", value: "Singapore Dollar" },
  //       { key: "SHP", value: "St Helena Pound" },
  //       { key: "SIT", value: "Tolar" },
  //       { key: "SKK", value: "Slovak Koruna" },
  //       { key: "SLL", value: "Leone" },
  //       { key: "SOS", value: "Somali Shilling" },
  //       { key: "SRG", value: "Surinam Guilder" },
  //       { key: "STD", value: "Dobra" },
  //       { key: "SUR", value: "Union of Soviet Socialist Republics Rouble" },
  //       { key: "SVC", value: "El Salvadorian Colón" },
  //       { key: "SYP", value: "Syrian Pound" },
  //       { key: "SZL", value: "Lilangeni" },
  //       { key: "THB", value: "Baht" },
  //       { key: "TJR", value: "Tajik Rouble" },
  //       { key: "TMM", value: "Turkmenistani Manat" },
  //       { key: "TND", value: "Tunisian Dinar" },
  //       { key: "TOP", value: "Pa'anga" },
  //       { key: "TPE", value: "Timorian Escudo" },
  //       { key: "TRL", value: "Turkish Lira" },
  //       { key: "TTD", value: "Trinidad and Tobago Dollar" },
  //       { key: "TWD", value: "Taiwan Dollar" },
  //       { key: "TZS", value: "Tanzanian Shilling" },
  //       { key: "UAH", value: "Hryvna" },
  //       { key: "UAK", value: "Karbovanet" },
  //       { key: "UGS", value: "Ugandan Shilling" },
  //       { key: "UKP", value: "Incorrectly used for GBP" },
  //       { key: "USD", value: "United States Dollar" },
  //       { key: "USN", value: "United States Dollar (Next day)" },
  //       { key: "USS", value: "United States Dollar (Same day)" },
  //       {
  //         key: "UYP",
  //         value: "Uruguayan Peso, replaced by Uruguayan New Peso (UYU)",
  //       },
  //       { key: "UYU", value: "Uruguayan New Peso" },
  //       { key: "UZS", value: "Uzbekistani Som" },
  //       { key: "VEB", value: "Bolivar" },
  //       { key: "VND", value: "Viet Nam Dông" },
  //       { key: "VUV", value: "Vatu" },
  //       { key: "WST", value: "Tala" },
  //       { key: "XAF", value: "Franc de la Communauté financière africaine" },
  //       { key: "XAU", value: "Gold" },
  //       { key: "XBA", value: "European Composite Unit" },
  //       { key: "XBB", value: "European Monetary Unit" },
  //       { key: "XBC", value: "European Unit of Account 9" },
  //       { key: "XBD", value: "European Unit of Account 17" },
  //       { key: "XCD", value: "East Caribbean Dollar" },
  //       {
  //         key: "XDR",
  //         value: "International Monetary Fund Special Drawing Rights",
  //       },
  //       {
  //         key: "XEU",
  //         value: "ECU (not an official currency, replaced by the Euro)",
  //       },
  //       { key: "XOF", value: "West African Franc" },
  //       { key: "XPF", value: "Franc des Comptoirs français du Pacifique" },
  //       { key: "YDD", value: "South Yemeni Dinar" },
  //       { key: "YER", value: "Yemeni Riyal" },
  //       { key: "YUD", value: "Yugoslavian New Dinar (no longer in use)" },
  //       { key: "ZAL", value: "Rand (financial)" },
  //       { key: "ZAR", value: "Rand" },
  //       { key: "ZMK", value: "Zambian Kwacha" },
  //       { key: "ZRZ", value: "Replaced by CDZ" },
  //       { key: "ZWD", value: "Zimbabwe Dollar" },
  //     ],
  //   };
  dropdownFields.nationality1 = dropdownFields.incorporation_country_code;
  dropdownFields.director_issue_country =
    dropdownFields.incorporation_country_code;
  const isDropdown = (fieldName) => {
    return Object.keys(dropdownFields).includes(fieldName);
  };

  // return (
  //   <form>
  //     <Grid container spacing={2}>
  //       {Object.keys(formData).map((field, index) => {
  //         if (field === "goods_services") return null; // Skip the goods_services field

  //         return (
  //           <Grid item xs={3} key={index}>
  //             {isDropdown(field) ? (
  //               <FormControl fullWidth>
  //                 <InputLabel id={`${field}-label`}>
  //                   {toLabel(field)}
  //                 </InputLabel>
  //                 <Select
  //                   labelId={`${field}-label`}
  //                   id={field}
  //                   name={field}
  //                   value={formData[field]}
  //                   onChange={handleInputChange}
  //                   label={toLabel(field)}
  //                 >
  //                   {(field === "issue_country" ||
  //                   field === "incorporation_country"
  //                     ? dropdownFields["incorporation_country_code"]
  //                     : dropdownFields[field]
  //                   ).map((option) => (
  //                     <MenuItem key={option.key} value={option.key}>
  //                       {option.value}
  //                     </MenuItem>
  //                   ))}
  //                 </Select>
  //               </FormControl>
  //             ) : (
  //               <TextField
  //                 name={field}
  //                 label={toLabel(field)}
  //                 fullWidth
  //                 value={formData[field]}
  //                 onChange={handleInputChange}
  //                 type={isDateField(field) ? "date" : "text"}
  //                 InputLabelProps={isDateField(field) ? { shrink: true } : {}}
  //                 disabled={staticFields.includes(field)}
  //               />
  //             )}
  //           </Grid>
  //         );
  //       })}

  //       {formData.goods_services.map((item, index) => (
  //         <React.Fragment key={index}>
  //           <Grid item xs={3}>
  //             <FormControl fullWidth>
  //               <InputLabel id={`item-type-label-${index}`}>
  //                 Item Type
  //               </InputLabel>
  //               <Select
  //                 labelId={`item-type-label-${index}`}
  //                 id={`item_type-${index}`}
  //                 name="item_type"
  //                 value={item.item_type}
  //                 onChange={(e) => handleInputChange(e, index)}
  //                 label="Item Type"
  //               >
  //                 {dropdownFields.item_type.map((type) => (
  //                   <MenuItem key={type.key} value={type.key}>
  //                     {type.value}
  //                   </MenuItem>
  //                 ))}
  //               </Select>
  //             </FormControl>
  //           </Grid>
  //           <Grid item xs={3}>
  //             <TextField
  //               label="Status Comments"
  //               name="status_comments"
  //               fullWidth
  //               value={item.status_comments}
  //               onChange={(e) => handleInputChange(e, index)}
  //             />
  //           </Grid>
  //           <Grid item xs={3}>
  //             <TextField
  //               label="Disposed Value"
  //               name="disposed_value"
  //               fullWidth
  //               value={item.disposed_value}
  //               onChange={(e) => handleInputChange(e, index)}
  //             />
  //           </Grid>
  //           <Grid item xs={2}>
  //             <FormControl fullWidth>
  //               <InputLabel id="currency-code-label">Currency Code</InputLabel>
  //               <Select
  //                 labelId="currency-code-label"
  //                 id="currency_code"
  //                 name="currency_code"
  //                 value={formData.currency_code}
  //                 onChange={handleInputChange}
  //                 label="Currency Code"
  //               >
  //                 {dropdownFields.currency_code.map((currency) => (
  //                   <MenuItem key={currency.key} value={currency.key}>
  //                     {currency.value}
  //                   </MenuItem>
  //                 ))}
  //               </Select>
  //             </FormControl>
  //           </Grid>
  //           <Grid item xs={1}>
  //             <IconButton onClick={() => removeItem(index)}>
  //               <RemoveCircleOutlineIcon />
  //             </IconButton>
  //           </Grid>
  //         </React.Fragment>
  //       ))}
  //       <Grid item xs={5}>
  //         <Button startIcon={<AddCircleOutlineIcon />} onClick={addItem}>
  //           Add Transaction
  //         </Button>
  //       </Grid>
  //       <Grid item xs={12} style={{ textAlign: "right" }}>
  //         <Button variant="outlined" style={{ marginRight: 8 }}>
  //           Cancel
  //         </Button>
  //         <Button variant="contained" style={{ marginRight: 8 }}>
  //           Done
  //         </Button>
  //         <Button variant="contained" color="primary" onClick={generateXML}>
  //           Generate XML
  //         </Button>
  //       </Grid>
  //     </Grid>
  //   </form>
  // );
  //   const dashBoardUser = JSON.parse(localStorage.getItem("DashBoardUser"));

  return (
    <form>
      <Grid container spacing={2}>
        {/* Company Details Section */}
        <br />
        <br />
        <Grid container spacing={2} margin={0}>
          <br />
          <br />

          <Grid item xs={4}>
            <Typography
              component="div"
              style={{
                whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                overflow: "hidden", // Hide any overflow content
                textOverflow: "ellipsis", // Show ellipsis (...) for overflow text
              }}
            >
              <strong>Reporting Entity ID:</strong> {formData["rentity_id"]}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="div"
              style={{
                whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                overflow: "hidden", // Hide any overflow content
                textOverflow: "ellipsis", // Show ellipsis (...) for overflow text
              }}
            >
              <strong>Report Entity:</strong>{" "}
              {/* {"BABA LUXURY JEWELLERY TRADING L.L.C"} */}{" "}
              {user?.name}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography component="div">
              <strong>Submission Date:</strong>{" "}
              {moment().format("YYYY-MM-DDTHH:mm:ss")}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} margin={0}>
          <br />
          <br />

          <Grid item xs={6}>
            {/* <Typography component="div"> DESCRIPTION OF REPORT </Typography> */}
            <TextField
              name={"reason"}
              label={"Description of Report"}
              fullWidth
              value={formData["reason"]}
              onChange={handleInputChange}
              disabled={false}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name={"entity_reference"}
              label={"Reporting Entity Ref. no"}
              fullWidth
              value={formData["entity_reference"]}
              onChange={handleInputChange}
              disabled={staticFields.includes("entity_reference")}
            />
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <TextField
            name={"transaction_reason"}
            label={"Transaction Reason"}
            fullWidth
            multiline
            rows={2}
            value={
              "Precious metals and stones (jewelry and watches included) transactions with entities/companies in transactions equal to or exceeding AED 55,000 or its equivalent in other currencies, in cash or through international wire transfer"
            }
            disabled={true}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            name={"reason_for_reporting"}
            label={"Reason for Reporting"}
            fullWidth
            multiline
            rows={2}
            value={formData["reason_for_reporting"]}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" color={"secondary"}>
            <strong>Report Party</strong>
          </Typography>
          <Grid container spacing={2} paddingTop={2}>
            {[
              "name",
              "incorporation_number",
              "incorporation_legal_form",
              "incorporation_date",
              // "entity_reference",
              // "address",
              // "state",
              "incorporation_country_code",
            ] // Add other relevant fields for Company Details
              .map((field, index) => (
                <Grid item xs={3} key={index}>
                  {isDropdown(field) ? (
                    <FormControl fullWidth>
                      <InputLabel id={`${field}-label`}>
                        {toLabel(field)}
                      </InputLabel>
                      {/* <Select
                          labelId={`${field}-label`}
                          id={field}
                          name={field}
                          value={formData[field]}
                          onChange={handleInputChange}
                          label={toLabel(field)}
                        >
                          {dropdownFields[field]?.map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select> */}
                      <Select
                        labelId={`${field}-label`}
                        id={field}
                        name={field}
                        value={formData[field]}
                        onChange={(e) => handleInputChange(e)}
                        label={toLabel(field)}
                      >
                        {dropdownFields[field].map((option) => (
                          <MenuItem key={option.key} value={option.key}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      name={field}
                      label={toLabel(field)}
                      fullWidth
                      value={formData[field]}
                      onChange={handleInputChange}
                      // // InputProps={{
                      // //   inputComponent: TextareaAutosize,
                      // //   inputProps: {
                      // //     minRows: 3,
                      // //     maxRows: 6,
                      // //   },
                      // }}
                      type={isDateField(field) ? "date" : "text"}
                      disabled={staticFields.includes(field)}
                      InputLabelProps={
                        isDateField(field) ? { shrink: true } : {}
                      }
                    />
                  )}
                </Grid>
              ))}
            <Grid item xs={3}>
              <TextField
                // name="tax_reg_number"
                label="Tax reg no."
                fullWidth
                value={formData["tax_reg_number"]}
                onChange={handleInputChange}
                disabled={false}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Identification Details Section
          <Grid item xs={12}>
            <Typography variant="h6">
              {" "}
              <strong>Controlling Person(s)/ Beneficial Owner(s)</strong>
            </Typography>
            <Grid container spacing={2} paddingTop={2}>
              {[
                "role",
                "director_first_name",
                "director_last_name",
                "director_birthdate",
                "director_identification_type",
                "director_id_number",
                "director_issue_date",
                "director_expiry_date",
                "director_issue_country",
              ] // Add other relevant fields for Identification Details
                .map((field, index) => (
                  <Grid item xs={3} key={index}>
                    {isDropdown(field) ? (
                      <FormControl fullWidth>
                        <InputLabel id={`${field}-label`}>
                          {toLabel(field)}
                        </InputLabel>
                  
                        <Select
                          labelId={`${field}-label`}
                          id={field}
                          name={field}
                          value={formData[field]}
                          onChange={(e) => handleInputChange(e)}
                          label={toLabel(field.replace(/^irector_/, ""))}
                        >
                          {dropdownFields[field].map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <TextField
                        name={field}
                        label={
                          field === "nationality1"
                            ? "Issue Country"
                            : toLabel(field)
                        }
                        fullWidth
                        value={formData[field]}
                        onChange={handleInputChange}
                        type={isDateField(field) ? "date" : "text"}
                        InputLabelProps={
                          isDateField(field) ? { shrink: true } : {}
                        }
                      />
                    )}
                  </Grid>
                ))}
            </Grid>
          </Grid> */}

        {/* Identification Details Section */}
        <Grid item xs={12}>
          <Typography variant="h6" color={"secondary"}>
            <strong>Controlling Person/ Beneficial Owner</strong>
          </Typography>
          {/* <Grid container spacing={2} paddingTop={2}>
            {[
              "director_role",
              "director_first_name",
              "director_last_name",
              "director_birthdate",
              "director_identification_type",
              "director_id_number",
              "director_issue_date",
              "director_expiry_date",
              "director_issue_country",
            ].map((field, index) => {
              // Remove 'director_' prefix for the label
              const label = toLabel(field.replace(/^director_/, ""));

              return (
                <Grid item xs={3} key={index}>
                  {isDropdown(field) ? (
                    <FormControl fullWidth>
                      <InputLabel id={`${field}-label`}>{label}</InputLabel>
                      <Select
                        labelId={`${field}-label`}
                        id={field}
                        // name={field}
                        value={formData[field]}
                        onChange={(e) => handleInputChange(e)}
                        label={label}
                      >
                        {dropdownFields[field].map((option) => (
                          <MenuItem key={option.key} value={option.key}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      //   name={field}
                      label={label}
                      fullWidth
                      value={formData[field]}
                      onChange={handleInputChange}
                      type={isDateField(field) ? "date" : "text"}
                      InputLabelProps={
                        isDateField(field) ? { shrink: true } : {}
                      }
                    />
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Grid> */}
          <Grid container spacing={2} paddingTop={2}>
            {/* Role Field */}
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel id="director_role-label">Role</InputLabel>
                {/* <Select
                  labelId="director_role-label"
                  id="director_role"
                  name="director_role"
                  value={formData.director_role}
                  onChange={handleInputChange} // Updates the specific field
                  label="Role"
                > */}
                <Select
                  labelId="director_role-label"
                  id="director_role"
                  name="director_role" // This must match the key in `formData`
                  value={formData.director_role}
                  onChange={(e) => handleInputChange(e)}
                  label={toLabel("director_role")} // Dynamically generate label
                >
                  {dropdownFields.director_role.map((option) => (
                    <MenuItem key={option.key} value={option.key}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* First Name Field */}
            <Grid item xs={3}>
              <TextField
                label="First Name"
                fullWidth
                value={formData.director_first_name}
                onChange={handleInputChange}
                type="text"
              />
            </Grid>

            {/* Last Name Field */}
            <Grid item xs={3}>
              <TextField
                label="Last Name"
                fullWidth
                value={formData.director_last_name}
                onChange={handleInputChange}
                type="text"
              />
            </Grid>

            {/* Birthdate Field */}
            <Grid item xs={3}>
              <TextField
                label="Birthdate"
                fullWidth
                value={formData.director_birthdate}
                onChange={handleInputChange}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Identification Type Field */}
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel id="director_identification_type-label">
                  Identification Type
                </InputLabel>
                <Select
                  labelId="director_identification_type-label"
                  id="director_identification_type"
                  value={formData.director_identification_type}
                  onChange={(e) => handleInputChange(e)}
                  label="Identification Type"
                >
                  {dropdownFields.director_identification_type.map((option) => (
                    <MenuItem key={option.key} value={option.key}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* ID Number Field */}
            <Grid item xs={3}>
              <TextField
                label="ID Number"
                fullWidth
                value={formData.director_id_number}
                onChange={handleInputChange}
                type="text"
              />
            </Grid>

            {/* Issue Date Field */}
            <Grid item xs={3}>
              <TextField
                label="Issue Date"
                fullWidth
                value={formData.director_issue_date}
                onChange={handleInputChange}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Expiry Date Field */}
            <Grid item xs={3}>
              <TextField
                label="Expiry Date"
                fullWidth
                value={formData.director_expiry_date}
                onChange={handleInputChange}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Issue Country Field */}
            <Grid item xs={3}>
              <FormControl fullWidth>
                <InputLabel id="director_issue_country-label">
                  Issue Country
                </InputLabel>
                <Select
                  labelId="director_issue_country-label"
                  id="director_issue_country"
                  value={formData.director_issue_country}
                  onChange={(e) => handleInputChange(e)}
                  label="Issue Country"
                >
                  {dropdownFields.director_issue_country.map((option) => (
                    <MenuItem key={option.key} value={option.key}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        {/* Role and Transactions Section */}
        <Grid item xs={12}>
          <Typography variant="h6" color={"secondary"}>
            <strong> Transaction Items </strong>
          </Typography>
          <Grid container spacing={2}>
            {[] // Add other relevant fields for Role and Transactions
              .map((field, index) => (
                <Grid item xs={3} key={index}>
                  {isDropdown(field) ? (
                    <FormControl fullWidth>
                      <InputLabel id={`${field}-label`}>
                        {toLabel(field)}
                      </InputLabel>
                      <Select
                        labelId={`${field}-label`}
                        id={field}
                        name={field}
                        value={formData[field]}
                        onChange={handleInputChange}
                        label={toLabel(field)}
                      >
                        {dropdownFields[field]?.map((option) => (
                          <MenuItem key={option.key} value={option.key}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      name={field}
                      label={toLabel(field)}
                      fullWidth
                      value={formData[field]}
                      onChange={handleInputChange}
                      type={isDateField(field) ? "date" : "text"}
                      InputLabelProps={
                        isDateField(field) ? { shrink: true } : {}
                      }
                    />
                  )}
                </Grid>
              ))}
            {formData.goods_services.map((item, index) => (
              <React.Fragment key={index}>
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <InputLabel id={`item-type-label-${index}`}>
                      Item Type
                    </InputLabel>
                    <Select
                      labelId={`item-type-label-${index}`}
                      id={`item_type-${index}`}
                      name="item_type"
                      value={item.item_type}
                      onChange={(e) => handleInputChange(e, index)}
                      label="Item Type"
                    >
                      {dropdownFields.item_type.map((type) => (
                        <MenuItem key={type.key} value={type.key}>
                          {type.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <InputLabel id="currency-code-label">
                      Currency Code
                    </InputLabel>
                    <Select
                      labelId="currency-code-label"
                      id="currency_code"
                      name="currency_code"
                      value={item.currency_code}
                      onChange={(e) => handleInputChange(e, index)}
                      label="Currency Code"
                    >
                      {dropdownFields.currency_code.map((currency) => (
                        <MenuItem key={currency.key} value={currency.key}>
                          {currency.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="Disposed Value"
                    name="disposed_value"
                    fullWidth
                    value={item.disposed_value}
                    type="number"
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    label="Status Comments"
                    name="status_comments"
                    fullWidth
                    value={item.status_comments}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton onClick={() => removeItem(index)}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12}>
              <Button
                color="success"
                startIcon={<AddCircleOutlineIcon />}
                onClick={addItem}
              >
                Add Transaction
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/* Submit Section */}
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginRight: 8 }}
            onClick={handleCancel} // Reset formData to null
          >
            Close
          </Button>
          <Button
            color="success"
            variant="contained"
            onClick={
              submitData
              // generateXML
            }
            disabled={isGenerateXMLDisabled()} // Disable the button based on the condition
          >
            Generate XML
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Dpmsr;

// const SearchEntities = ({ onSelect }) => {
//   const [inputValue, setInputValue] = useState("");

//   // Use RTK Query with inputValue as the query parameter
//   const { data, isFetching } = useGetSearchEntitiesQuery(
//     { query: inputValue, limit: 10 },
//     { skip: inputValue.length < 3 } // Skip the query until the user types at least 3 characters
//   );

//   const options = data?.results || [];

//   return (
//     <Autocomplete
//       options={options}
//       getOptionLabel={(option) => option.fullLegalName || ""}
//       loading={isFetching}
//       onInputChange={(event, value) => setInputValue(value)}
//       onChange={(event, value) => onSelect(value)} // Pass selected entity to parent
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           label="Search Entities"
//           variant="outlined"
//           InputProps={{
//             ...params.InputProps,
//             endAdornment: (
//               <>
//                 {isFetching ? <CircularProgress size={20} /> : null}
//                 {params.InputProps.endAdornment}
//               </>
//             ),
//           }}
//         />
//       )}
//     />
//   );
// };

const SearchEntities = ({ onSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedInput] = useDebounce(inputValue, 300);

  // Fetch data using RTK Query with a debounce and conditional skip
  const { data, isFetching } = useGetSearchEntitiesQuery(
    { query: debouncedInput, limit: 10 }
    // { skip: debouncedInput.length < 3 }
  );

  const options = Array.isArray(data) ? data : []; // Ensure data is an array
  console.log(data);
  const noOptionsText =
    inputValue.length >= 3 && !isFetching && options.length === 0
      ? "No results found"
      : "Type at least 3 characters to search";

  return (
    <Autocomplete
      options={options}
      //   getOptionLabel={(option) => option.fullLegalName || ""}
      getOptionLabel={(option) => {
        console.log("Option:", option);
        return option.fullLegalName || "";
      }}
      loading={isFetching}
      noOptionsText={noOptionsText}
      onInputChange={(event, value) => setInputValue(value)}
      onChange={(event, value) => onSelect(value)} // Pass selected entity to parent
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search Entities"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      clearOnEscape
    />
  );
};

function findCountryKeyByValue(countries, searchValue) {
  console.log(searchValue);
  if (!searchValue) return null;

  const country = countries.find(
    (country) => country.value.toLowerCase() === searchValue.toLowerCase()
  );

  return country ? country.key : null; // Return the key if found, otherwise null
}

function hasPEP(data) {
  if (!data || !Array.isArray(data.shareHolders)) {
    return false; // Return false if data is invalid or there are no shareholders
  }

  return data.shareHolders.some((shareholder) => shareholder.pep === true);
}

const findCountryKey = (countryName) => {
  if (!countryName) return null;

  // Convert the object into an array of entries [key, value]
  const entries = Object.entries(countryListAlpha2);

  // Find the entry where the value matches the given name (case-insensitively)
  const entry = entries.find(
    ([, value]) => value.toLowerCase() === countryName.toLowerCase()
  );

  // Return the key if found, otherwise return null
  return entry ? entry[0] : null;
};

function selectAuthorizedOrUBO(shareholders) {
  return (
    shareholders?.find(
      (shareholder) => shareholder.isAuthorizedSignatory || shareholder.ubo
    ) || shareholders?.[0]
  );
}
